module.exports = __webpack_public_path__ + "static/img/3.0d2274e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msbl/3.jpg
// module id = RuYR
// module chunks = 1